import ISPGetItemResponse from '@ms/odsp-datasources/lib/dataSources/item/spListItemRetriever/interfaces/ISPGetItemResponse';
import { IFaceted, pack } from '@ms/items-view/lib/private/models/Facet';
import { driveAccessTokenFacet, downloadAsZipApiUrlFacet } from '@ms/items-view/lib/private/facets/MicroServiceFacets';
import { getDownloadAsZipUrl } from '@ms/odsp-microservice/lib/microService/helpers/MicroServiceHelper';
import { MediaTAUseVroomV21 } from '@ms/odsp-microservice/lib/microService/IMicroServiceDataSource';
import { isSPFeatureEnabled } from '@ms/odsp-utilities/lib/features/FeaturesBasic';
import ISpPageContext from '@ms/odsp-datasources/lib/interfaces/ISpPageContext';

// 6 hours - from $\dev\sts\stsom\MicroService\MediaTAUrlGenerator.cs
const TOKEN_EXPIRATION_IN_SECONDS = 6 * 60 * 60;

export function buildMicroServiceFacets(response: ISPGetItemResponse, currentPageContext: ISpPageContext | undefined): IFaceted {
  let pageContext = currentPageContext;
  if (!pageContext) {
    pageContext = response && response.PageContextInfo && JSON.parse(response.PageContextInfo);
  }
  const listSchema = response && response.ListSchema;

  let driveAccessToken: {
    accessToken: string;
    tokenUrl: string;
    timeReceived: Date;
    expirationTime: Date
  } | undefined;
  let downloadAsZipApiUrl = '';

  const useVroom21 = (isSPFeatureEnabled(MediaTAUseVroomV21, pageContext && pageContext.ExpFeatures || []));
  if (!!pageContext && !!listSchema) {
    downloadAsZipApiUrl = getDownloadAsZipUrl(listSchema as { [key: string]: string },
      pageContext && pageContext.viewOnlyExperienceEnabled || false,
      pageContext && pageContext.env || '');
  }

  if (!!listSchema) {
    const driveUrl = useVroom21 ? listSchema['.driveUrlV21'] : listSchema['.driveUrl'];

    let accessToken = useVroom21 ? listSchema['.driveAccessTokenV21'] : listSchema['.driveAccessToken'];
    if (accessToken && accessToken.indexOf('access_token=') === 0) {
      accessToken = accessToken.substring(13);
    }

    if (driveUrl && accessToken) {
      const timeReceived = new Date();

      driveAccessToken = {
        accessToken: accessToken,
        tokenUrl: driveUrl,
        timeReceived: timeReceived,
        expirationTime: new Date(timeReceived.getTime() + (TOKEN_EXPIRATION_IN_SECONDS * 1000)),
      };
    }
  }

  return {
    ...pack({}, {}),
    ...(driveAccessToken ? driveAccessTokenFacet.pack(driveAccessToken) : {}),
    ...(downloadAsZipApiUrl ? downloadAsZipApiUrlFacet.pack(downloadAsZipApiUrl) : {})
  };
}
